export default __webpack_public_path__ + "d1e242853fd00ee258c4b1c7c8942800.png";